import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as Api from '@/app/state-serialization/api'
import { ChoiceAnswer } from './choice-interfaces'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';

@injectable()
export class ChoiceQuestionAnswerProtobufSerializer implements Api.StateSerializationPlugin<ChoiceAnswer> {

  key = { id: 10, name: { ns: 'suspend-data', name: 'question-answer-choice' }, format: 'protobuf' }

  serialize(data: ChoiceAnswer): Result<Uint8Array, Api.SerializerError> {

    const message = new ChoiceAnswerProtoMessage({
      answerIds: data.answerIds
    })

    return ProtobufSerializer.serialize<ChoiceAnswerProtoMessage>(message, ChoiceAnswerProtoMessage)
  }

  deserialize(content: Uint8Array): Result<ChoiceAnswer, Api.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<ChoiceAnswerProtoMessage>(content,
                                                                                       ChoiceAnswerProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: ChoiceAnswer = {
      answerIds: message.answerIds
    }
    
    return ok(result)
  }
}

@Type.d('ChoiceAnswerProtoMessage')
class ChoiceAnswerProtoMessage extends Message<ChoiceAnswerProtoMessage> {

  @Field.d(1, 'string', 'repeated')
  answerIds: string[]
}
